import { baseUrl } from 'config/config';
import { useState, useEffect } from 'react';
import { getApiCall, postApiCall, postApiCallNoToken } from './apiHelper';
import { DashboardResponse, FilterModel, Lease, LeaseFilters } from '../all_Interfaces';

export class RawDataService {

    async FetchLeaseData() {
        try {
            var url = `${baseUrl}Leases/LeaseData`;
            const response = await getApiCall<string>(url);

            return response;
        } catch (error: any) {
            console.error('Error in GET request:', error);
        }
    }

    async FetchAuditData() {

        try {
            var url = `${baseUrl}AuditLog/AuditData`;
            const response = await getApiCall<string>(url);

            return response;
        } catch (error: any) {
            console.error('Error in GET request:', error);
        }

    }
}
